// 공통 Enum 타입들
export enum UserSort {
  USER = 'U',
  ADMIN = 'A',
  COMMUNITY_ADMIN = 'C',
  VERITAS_ADMIN = 'V',
}

export enum SocialProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
}

export enum HighschoolCategoryEnum {
  IB = 'IB',
  AP = 'AP',
  A_LEVEL = 'A_LEVEL',
  FOREIGN = 'FOREIGN',
  LOCAL = 'LOCAL',
  ETC = 'ETC',
}

export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum AcademicStatusEnum {
  ENROLLED = 'ENROLLED', // 재학
  REST = 'REST', // 휴학
  GRADUATED = 'GRADUATED', // 졸업
  COMPLETED = 'COMPLETED', // 수료
}

export enum TutoringMethodEnum {
  ALL = 'ALL',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export enum ApplicationStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum AdmissionSortEnum {
  '3Y' = '3Y', // 3년 특례
  '12Y' = '12Y', // 12년 특례
  EARLY = 'EARLY', // 수시
  FOREIGN = 'FOREIGN', // 해외대 전형
}

export enum UniversityExistenceEnum {
  UNIVERSITY = 'UNIVERSITY_ONLY', // University만 존재
  ALL = 'ALL', // University, Major 모두 존재
  NONE = 'NONE', // University, Major 둘다 존재 x
}

export enum EduApplicationEnum {
  NEW = 'NEW', // 신규 신청
  UNIVERSITY_MODIFY = 'UNIVERSITY_MODIFY', // 대학 정보 수정
}

// 공통 타입들
export type UserEduUniversityDto = {
  universityName: string;
  departmentName: string;
  studentNumber: string;
  academicStatus: AcademicStatusEnum;
  proofFileUris: string[];
};

export type UserPassUniversityDto = {
  universityName: string;
  departmentName: string;
  proofFileUris: string[];
};

export type UserUniversityReqType = {
  eduUniversities: UserEduUniversityDto[];
  passUniversities: UserPassUniversityDto[];
};

export type UserEduUniversityType = {
  id: string;
  universityId: string;
  universityName: string;
  universityImage: string;
  departmentName: string;
  studentNumber: string;
  academicStatus: AcademicStatusEnum;
  proofFileUris: string[];
  isProofed: boolean;
};

export type UserPassUniversityType = {
  id: string;
  universityId: string;
  universityName: string;
  universityImage: string;
  departmentName: string;
  proofFileUris: string[];
  isProofed: boolean;
};

export type UserType = {
  id: string;
  email: string;
  name: string;
  nickname: string;
  createdAt: string;
  updatedAt: string;
};

// 공통 Request 타입들
export type GetAllUsersApplicationReqType = {
  page: number;
  size: number;
  keyword?: string;
  isApproved?: boolean;
};

export type PatchApplicationApprovalReqType = {
  status: ApplicationStatusEnum;
  applicationId: string;
  rejectReason?: string;
};

export type GetUserApplicationStatusReqType = {
  userId: string;
};

export type GetUserExistReqType = {
  userId: string;
};

export type GetUserDetailReqType = {
  userId: string;
};

export type DeleteAdminReqType = {
  id: string;
};

// 공통 검색 필터 타입
export type SummarySearchReqType = {
  gender?: GenderEnum;
  ageMin?: number;
  ageMax?: number;
  universityId?: string;
  universityMajorId?: string;
  studentNumberMin?: string;
  studentNumberMax?: string;
  academicStatus?: AcademicStatusEnum;
  tutoringMethod?: TutoringMethodEnum;
  tuitionMin?: number;
  tuitionMax?: number;
  admissionSort?: AdmissionSortEnum[];
  highschoolCategory?: HighschoolCategoryEnum[];
  page: number;
  size: number;
};

export type AdminDetailsReqType = {
  keyword?: string;
  page?: number;
  size?: number;
};
